import React, { createContext, useContext, useEffect, useState } from "react";
import { loadState, saveState, clearState } from "@/lib/storage";
import { PILLARS } from "@/data/pillars";

const emptyAnswers = () =>
  Object.fromEntries(PILLARS.map((p) => [p.id, Array(5).fill(null)]));

const emptyCompany = {
  nome: "",
  empresa: "",
  cargo: "",
  colaboradores: "",
  cidade: "",
  estado: "",
  segmento: "",
  email: "",
  telefone: "",
};

const DiagnosticContext = createContext(null);

export function DiagnosticProvider({ children }) {
  const [company, setCompany] = useState(emptyCompany);
  const [answers, setAnswers] = useState(emptyAnswers);
  const [result, setResult] = useState(null);

  useEffect(() => {
    const s = loadState();
    if (s) {
      if (s.company) setCompany({ ...emptyCompany, ...s.company });
      if (s.answers) {
        const merged = emptyAnswers();
        PILLARS.forEach((p) => {
          if (Array.isArray(s.answers[p.id])) {
            merged[p.id] = s.answers[p.id];
          }
        });
        setAnswers(merged);
      }
      if (s.result) setResult(s.result);
    }
  }, []);

  useEffect(() => {
    saveState({ company, answers, result });
  }, [company, answers, result]);

  const setAnswer = (pillarId, index, value) => {
    setAnswers((prev) => {
      const next = { ...prev, [pillarId]: [...(prev[pillarId] || [])] };
      next[pillarId][index] = value;
      return next;
    });
  };

  const reset = () => {
    setCompany(emptyCompany);
    setAnswers(emptyAnswers());
    setResult(null);
    clearState();
  };

  return (
    <DiagnosticContext.Provider
      value={{
        company,
        setCompany,
        answers,
        setAnswer,
        setAnswers,
        result,
        setResult,
        reset,
      }}
    >
      {children}
    </DiagnosticContext.Provider>
  );
}

export function useDiagnostic() {
  const ctx = useContext(DiagnosticContext);
  if (!ctx)
    throw new Error("useDiagnostic must be used within DiagnosticProvider");
  return ctx;
}
